import { createFileRoute } from "@tanstack/react-router";
import LegalPage from "@/components/LegalPage";
import { buildHead, breadcrumbLD } from "@/content/seo";

const TITLE = "Política de Cookies · Morningstar Yacht · Vilamoura";
const DESC = "Como o Morningstar Yacht (Vilamoura Dreams Cruises) utiliza cookies — cookies necessários, funcionais, de análise e publicidade, e como gerir o seu consentimento.";
const PATH = "/pt/politica-de-cookies";

export const Route = createFileRoute("/pt/politica-de-cookies")({
  component: () => (
    <LegalPage
      lang="pt"
      title="Política de Cookies"
      updated="Maio 2026"
      homeHref="/pt"
      backLabel="Voltar à página inicial"
      intro='Utilizamos cookies para melhorar a sua experiência de navegação, analisar o tráfego do site e personalizar conteúdos. Ao clicar em "Aceitar", consente a utilização de cookies. Pode alterar as suas preferências a qualquer momento nas definições do seu navegador.'
      sections={[
        {
          heading: "O que são cookies?",
          body: [
            "Os cookies são pequenos ficheiros de texto guardados no seu dispositivo quando visita um website. Ajudam o site a recordar as suas preferências e a melhorar a sua experiência.",
          ],
        },
        {
          heading: "Cookies necessários",
          body: [
            "Cookies essenciais para o funcionamento adequado do site — por exemplo, para guardar a sua escolha de consentimento e a preferência de idioma. Não podem ser desativados.",
          ],
        },
        {
          heading: "Cookies funcionais",
          body: ["Cookies que melhoram a funcionalidade ao guardar as suas preferências."],
        },
        {
          heading: "Cookies de análise",
          body: [
            "Cookies que recolhem dados anónimos sobre a utilização do site (por exemplo, Google Analytics), permitindo-nos melhorar o conteúdo e a navegação.",
          ],
        },
        {
          heading: "Cookies de publicidade",
          body: [
            "Cookies utilizados para medir a eficácia de campanhas publicitárias em diferentes websites.",
          ],
        },
        {
          heading: "Gerir o seu consentimento",
          body: [
            "Pode aceitar, rejeitar ou personalizar as categorias de cookies a qualquer momento através do banner de cookies do site, ou directamente nas definições do seu navegador.",
          ],
        },
        {
          heading: "Contacto",
          body: [
            'Para qualquer questão sobre esta política, contacte-nos em <a class="underline hover:text-gold" href="mailto:info@vilamouradreamscruises.com">info@vilamouradreamscruises.com</a>.',
          ],
        },
      ]}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      altPath: { en: "/cookie-policy", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Política de Cookies", path: PATH },
            ]),
          ),
        },
      ],
    }),
});